import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { iconLock, iconVictory } from '@change-corgi/design-system-legacy/icons';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { useIsSunriseEnabled } from '../../hooks/isSunriseEnabled';
import { usePetitionDetails } from '../../hooks/petitionDetails';

import { PetitionStatusHeader } from './components/PetitionStatusHeader';

function PetitionStatusHeaderContainerInner() {
	const { status, isVerifiedVictory } = usePetitionDetails();
	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();

	if (status === 'VICTORY') {
		return (
			<PetitionStatusHeader
				icon={iconVictory}
				headingColor={isSunriseEnabled ? 'sunrise.semantic.typography.inverse.strong' : undefined}
				iconColor={isSunriseEnabled ? 'sunrise.semantic.icon.inverse.strong' : 'primary-changeRed'}
				background={
					isSunriseEnabled
						? 'var(--Background-Dark-1, linear-gradient(90deg, var(--Blue-600, #0D4DFB) 36%, var(--Blue-500, #4771FF) 100%));'
						: 'primary-greyBackground'
				}
			>
				{isVerifiedVictory ? (
					<Translate value="fe.pages.petition_show.status.confirmed_victory" />
				) : (
					<Translate value="fe.pages.petition_show.status.victory" />
				)}
			</PetitionStatusHeader>
		);
	}

	if (status === 'CLOSED') {
		return (
			<PetitionStatusHeader icon={iconLock} iconColor="neutral-grey600" background="primary-greyBackground">
				<Translate value="fe.pages.petition_show.status.closed" />
			</PetitionStatusHeader>
		);
	}

	return null;
}

export function PetitionStatusHeaderContainer(): JSX.Element {
	return (
		<Box sx={{ display: ['block', 'none'] }}>
			<PetitionStatusHeaderContainerInner />
		</Box>
	);
}
